import styled, { css } from 'styled-components';

interface CellItemProps {
  backgroundColor: string;
  color: string;
}

interface ValueAreaProps {
  textAlign: string;
  fontWeight?: string | number;
}

export const CellItem = styled.div<CellItemProps>`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  align-self: center;
  ${({ color, backgroundColor }) => css`
    color: ${color};
    background-color: ${backgroundColor};
  `};
`;
export const ValueArea = styled.div<ValueAreaProps>`
  width: 100%;
  margin: 0 5px;
  text-align: ${({ textAlign }) => textAlign};
  font-weight: ${({ fontWeight }) => fontWeight};
`;
